export default "__VITE_PUBLIC_ASSET__6f451f84__"